import BaseField from "./BaseField";

export class ReCaptchaField extends BaseField{
    constructor(props) {
        super(props);
    }

    componentDidMount(){
        const script = document.createElement("script");
        script.type = "text/javascript";
        script.src = "https://www.google.com/recaptcha/api.js";
        document.head.appendChild(script);
        eval(script);
    }

    renderRecaptcha(){
        return(
            <div className="g-recaptcha" data-sitekey={this.props.sitekey} />
        )
    }

    render() {
        return (
            <div className={this.props.Columns}>
                <div className="field recaptcha">
                    {this.renderRecaptcha()}
                    {this.renderErrorMessage()}
                </div>
            </div>
        )
    }
}
export default ReCaptchaField;